// comonents
import MainPcHeader from 'components/organisms/headers/main/PC';
import MainMobileHeader from 'components/organisms/headers/main/Mobile';
import HeadLayout from 'components/layout/Head';
import BodyLayout from 'components/layout/Body';

/**
 * 메인 레이아웃
 * @param {import('react').PropsWithChildren<{mobileHeader?:JSX.Element;disableFooter?:boolean}>}
 */
const Layout = ({ mobileHeader = <MainMobileHeader />, disableFooter = false, children }) => {
  return (
    <>
      <HeadLayout mobile={mobileHeader} pc={<MainPcHeader />} />
      <BodyLayout disableFooter={disableFooter}>{children}</BodyLayout>
    </>
  );
};

export default Layout;
